import React from 'react'
import styled from 'styled-components'
import { Col, Row } from 'react-flexbox-grid'
import AditionalServices from 'components/AditionalServices'
import { Marginer } from 'components/Util'
import { replaceDots } from 'utils'

const Energy = ({ filters, ponta, cheia, vazio, super_vazio }) => {
  if (filters.tariff.value === 's') {
    return (<Number>{(vazio && replaceDots(vazio)) || '---'}</Number>)
  } else if (filters.tariff.value === 'b') {
    return (
      <div>
        <Number>
          <NumberLabel>Fora do vazio</NumberLabel>
          {(cheia && replaceDots(cheia)) || '---'}
        </Number>
        <Number>
          <NumberLabel>Vazio</NumberLabel>
          {(vazio && replaceDots(vazio)) || '---'}
        </Number>
      </div>)
  } else {
    return (
      <div>
        <Number>
          <NumberLabel>Ponta</NumberLabel>
          {(ponta && replaceDots(ponta)) || '---'}
        </Number>
        <Number>
          <NumberLabel>Cheias</NumberLabel>
          {(cheia && replaceDots(cheia)) || '---'}
        </Number>
        <Number>
          <NumberLabel>Vazio</NumberLabel>
          {(vazio && replaceDots(vazio)) || '---'}
        </Number>
      </div>
    )
  }
}

const EnergyGas = ({ filters, ...gasData }) => {
  // Back end doens't filter by "escalão" this so we have to 😅

  const field = gasData.escalao
  return (<Number>{(field && replaceDots(field)) || '---'}</Number>)
}

const TariffSummary = (props) => {
  return (
    <div>
      {props.tariff.electricityPriceList &&
      <Marginer top='24' right='0' bottom='0' left='0'>
        <Title>Eletricidade</Title>
        <Marginer top='12' right='0' bottom='0' left='0'>
          <Row>
            <Col xs={6} >
              <Label>Termo Potência <Unit>(€/dia)</Unit></Label>
              <Value>{replaceDots(props.tariff.prices.electricity.termo_fixo)}</Value>
            </Col>
            <Col xs={6} >
              <Label>Energia <Unit>(€/kWh)</Unit></Label>
              <Energy {...{ filters: props.entries.electric, ...props.tariff.prices.electricity }} />
            </Col>
          </Row>
        </Marginer>
      </Marginer>
      }
      {props.tariff.gasPriceList &&
      <Marginer top='48' right='0' left='0' bottom='0'>
        <Title>Gás Natural</Title>
        <Marginer top='12' right='0' bottom='0' left='0'>
          <Row>
            <Col xs={6} >
              <Label>Termo Fixo <Unit>(€/dia)</Unit></Label>
              <Value>{replaceDots(props.tariff.prices.gas.termo_fixo)}</Value>
            </Col>
            <Col xs={6} >
              <Label>Energia <Unit>(€/kWh)</Unit></Label>
              <EnergyGas {...{ filters: props.entries.gas, ...props.tariff.prices.gas }} />
            </Col>
          </Row>
        </Marginer>
      </Marginer>
      }
      <Marginer top='48' right='0' left='0' bottom='0'>
        <Row>
          <AditionalServices list={props.tariffInfo.additional_services} />
        </Row>
      </Marginer>
    </div>
  )
}

const Title = styled.span`
  display: block;
  color: #3E3E3E;
  font-family: Nunito;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
`

const Label = styled.span`
  color: #9C9C9C;
  font-family: Nunito;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
`

const Unit = styled.span`
  font-weight: normal;
`

const Value = styled.div`
  color: #676767;
  font-family: Nunito;
  font-size: 18px;
  font-weight: bold;
  line-height: 18px;
`

const Number = styled.span`
  color: #676767;
  font-size: 18px;
  font-weight: bold;
  line-height: 18px;
  display: flex;
  justify-content: space-between;
`

const NumberLabel = styled.span`
  color: #676767;
  font-size: 12px;
  font-weight: 100;

  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
`

export default TariffSummary



// WEBPACK FOOTER //
// ./src/components/TariffSummary/index.js